import { slice } from 'ramda'

import { NodeTypes, OperatorTypes, Operators, ParserTypes, TokenTypes } from '../../constants'
import createGreaterThanEqualOperator from '../pipes/createGreaterThanEqualOperator'
import { getTokenListPosition } from '../util'

const GreaterThanEqualOperator = {
  identify: (context, node) => node,
  is: (value) =>
    value &&
    value.type === NodeTypes.OPERATOR &&
    value.operatorType === OperatorTypes.GREATER_THAN_EQUAL,
  parse: (context, tokenList) => {
    const nextToken = tokenList.get(0)
    if (!nextToken) {
      throw new Error(
        `Expected operator '${Operators.GREATER_THAN_EQUAL}'. Instead reached the end of the file.`
      )
    }
    if (nextToken.type !== TokenTypes.OPERATOR_GREATER_THAN_EQUAL) {
      const { lastLineCharacterCount, lineCount } = getTokenListPosition(context, tokenList)
      throw new Error(
        `Expected operator '${Operators.GREATER_THAN_EQUAL}'. Instead was given '${
          tokenList.get(0).value
        }' at ${lineCount}:${lastLineCharacterCount}`
      )
    }
    return createGreaterThanEqualOperator({
      tokenList: slice(0, 1, tokenList)
    })
  },
  test: (context, tokenList) => tokenList.get(0).type === TokenTypes.OPERATOR_GREATER_THAN_EQUAL,
  type: ParserTypes.OPERATOR
}

export default GreaterThanEqualOperator
